import React from 'react';
import { Grid, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import Select from 'react-select';
import { Question } from 'components';
import { FilterHelper, translate } from 'utils/helpers';
import { ApplicationRolesService } from 'services';
import { useFetch } from 'hooks';
import useAccessRights from 'hooks/useAccessRights';
import { APPLICATION_BACK_OFFICE_ADMIN_ROLES } from 'utils/constants';

export const UserListFilter = ({ currentFilters, setCurrentFilters }) => {
  const { response: appRoles } = useFetch(
    () => ApplicationRolesService.getOptions(),
    [],
    []
  );

  const isBackOfficeAdmin = useAccessRights({ roles: APPLICATION_BACK_OFFICE_ADMIN_ROLES });

  const handleChangeInput = (key, value, label) => {
    setCurrentFilters(
      FilterHelper.setFiltersValue(currentFilters, key, value, label)
    );
  };

  const activeOptionsUserAccount = [
    { value: true, label: translate('common.withUserAccount') },
    { value: false, label: translate('common.withoutUserAccount') }
  ];

  const activeOptionsDatabilanAccess = [
    { value: true, label: translate('common.withDatabilanAccess') },
    { value: false, label: translate('common.withoutDatabilanAccess') }
  ];

  return (
    <Grid container direction="column">
      { isBackOfficeAdmin && (
      <TextField
        label={translate('common.company')}
        value={FilterHelper.getFiltersValue(currentFilters, 'companyName') || ''}
        onChange={(e) =>
          handleChangeInput('companyName', e.target.value, e.target.value)
        }
      />
      ) }
      <Question label={translate('common.roles')}>
        <Select
          isMulti
          options={appRoles || []}
          value={FilterHelper.getFiltersValue(currentFilters, 'roles')}
          onChange={(value) => handleChangeInput('roles', value, value)}
          isClearable
          isSearchable
          noOptionsMessage={() => translate('warnings.noOptionsAvailable')}
          styles={{ menuPortal: base => ({ ...base, zIndex: 2000 }) }}
        />
      </Question>

      { isBackOfficeAdmin && (
      <TextField
        label={translate('common.siren')}
        value={FilterHelper.getFiltersValue(currentFilters, 'siren') || ''}
        onChange={(e) =>
          handleChangeInput('siren', e.target.value, e.target.value)
        }
      />
      ) }

      <TextField
        label={translate('common.siret')}
        value={FilterHelper.getFiltersValue(currentFilters, 'siret') || ''}
        onChange={(e) =>
          handleChangeInput('siret', e.target.value, e.target.value)
        }
      />

      <TextField
        label={translate('common.institutionName')}
        value={FilterHelper.getFiltersValue(currentFilters, 'institutionName') || ''}
        onChange={(e) =>
          handleChangeInput('institutionName', e.target.value, e.target.value)
        }
      />

      <TextField
        label={translate('common.postalCode')}
        value={FilterHelper.getFiltersValue(currentFilters, 'postalCode') || ''}
        onChange={(e) =>
          handleChangeInput('postalCode', e.target.value, e.target.value)
        }
      />

      <TextField
        label={translate('common.city')}
        value={FilterHelper.getFiltersValue(currentFilters, 'city') || ''}
        onChange={(e) =>
          handleChangeInput('city', e.target.value, e.target.value)
        }
      />

      <Question label={translate('common.userAccount')}>
        <ToggleButtonGroup
          exclusive
          value={FilterHelper.getFiltersValue(currentFilters, 'active')}
          onChange={(_, value) => {
            handleChangeInput(
              'active',
              value,
              activeOptionsUserAccount.find(o => o.value === value)?.label
            );
          }}
        >
          <ToggleButton value={true}>
            {translate('common.yes')}
          </ToggleButton>

          <ToggleButton value={false}>
            {translate('common.no')}
          </ToggleButton>
        </ToggleButtonGroup>
      </Question>

      <Question label={translate('pageUserList.hasDatabilanRole')}>
          <ToggleButtonGroup
            exclusive
            value={FilterHelper.getFiltersValue(currentFilters, 'activeAndRole')}
            onChange={(_, value) => {
              handleChangeInput(
                'activeAndRole',
                value,
                activeOptionsDatabilanAccess.find(o => o.value === value)?.label
              );
            }}
          >
          <ToggleButton value={true}>
            {translate('common.yes')}
          </ToggleButton>

          <ToggleButton value={false}>
            {translate('common.no')}
          </ToggleButton>
        </ToggleButtonGroup>
      </Question>

    </Grid>
  );
};
